import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import {documentSizeAware} from "../../../../hoc/documentSizeAware"

const _NRTHorizontalStack = (props) => {

    let fractions =  props.fractions

    if (props.documentWidth <= 900 ) {
        fractions = props.mdFractions || fractions
    }

    if (props.documentWidth <= 500 ) {
        fractions = props.smFractions || fractions
    }



    const frs = fractions ?
        fractions.map(f => f + 'fr').join(' ') :
        `repeat(${props.children.length}, 1fr )`

    return (
        <div className={'nrt-form-horizontal-stack'}
             style={{
                 gridTemplateColumns: frs,
                 ...props.style
             }}>
            {props.children}
        </div>
    )
}

_NRTHorizontalStack.propTypes = {
    fractions: PropTypes.array,
    mdFractions: PropTypes.array,
    smFractions: PropTypes.array,
    style: PropTypes.object,
}

_NRTHorizontalStack.defaultProps = {

}

const NRTHorizontalStack = documentSizeAware(_NRTHorizontalStack)

export default NRTHorizontalStack



// WEBPACK FOOTER //
// ./src/components/_common/_containers/HorizontalStack/index.js